import type { RowToSkip } from '../types/whatsapp';

const cellClass = 'px-4 py-2 align-top text-xs text-gray-700';
const headerClass =
  'px-4 py-2 text-left text-xs font-medium uppercase text-gray-500';

export default function RowsToSkipTable({
  rowsToSkip,
}: {
  rowsToSkip: RowToSkip[];
}) {
  return (
    <div>
      <h4 className="mb-2 text-sm font-medium text-gray-700">
        Rows we will skip
      </h4>
      <div className="max-h-64 overflow-auto rounded-md border border-gray-200">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="sticky top-0 bg-gray-50">
            <tr>
              <th className={headerClass}>Row</th>
              <th className={headerClass}>Phone</th>
              <th className={headerClass}>Why</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200 bg-white">
            {rowsToSkip.map((row) => (
              <tr key={row.lineNumber}>
                <td className={`${cellClass} text-gray-500`}>
                  {row.lineNumber}
                </td>
                <td className={`${cellClass} whitespace-nowrap`}>
                  {row.phone || 'No phone'}
                </td>
                <td className={cellClass}>
                  {row.reasons.map((reason) => (
                    <p key={reason}>{reason}</p>
                  ))}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
